/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import BuildFeatures from '../environment/BuildFeatures';
import {TelemetryLevel} from '../metrics/MetricsConfiguration';

export default class TelemetryDefault {
  static get defaultTelemetryLevel(): TelemetryLevel {
    return TelemetryLevel[BuildFeatures.sendMetrics];
  }
}